<template>
    <div>
        <el-form label-width="160px">
            <div class="title"> {{ $t('client.role.roleInformation') }}
                <el-button size="small" class="sys-btn-default" @click="goEdit" style="float: right;">{{
                $t('common.edit')
            }}</el-button>
            </div>
            <el-form-item :label="$t('client.role.roleName') + '：'">
                <span class="normal-label">{{ dataForm.name }}</span>
            </el-form-item>
            <el-row>
                <el-col :span="16">
                    <el-form-item :label="$t('client.role.roleDescription') + '：'">
                        <span class="normal-label">{{ dataForm.description }}</span>
                    </el-form-item>
                </el-col>
            </el-row>

            <div class="title sys-split-line"> {{ $t('client.role.clientAuthority') }}</div>

            <MenuTreeConfig ref="menuTreeConfigRef" :setDisabledAttr="true"></MenuTreeConfig>

        </el-form>
    </div>
</template>

<script>
import MenuTreeConfig from '@/components/menuTreeConfig.vue'
import Cookies from 'js-cookie'
export default {
    props: {
        dataForm: {
            type: Object,
            default: {}
        },
    },
    components: {
        MenuTreeConfig
    },
    watch: {
        dataForm(newVal, oldVal) {
            this.dataForm = newVal;
            let url = this.$Api.rolePermissionTree + '/' + this.monitorId + '/' + this.dataForm.brandId + '/' + this.dataForm.id;
            this.$refs.menuTreeConfigRef.initDataList(url);
        }
    },
    data() {
        return {
            monitorId: Number(Cookies.get("monitorId")),
        }
    },
    created() {
    },
    methods: {
        goEdit() {
            this.$emit('updateType');
        },
    }
}
</script>